<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Add painting image</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block spinner-parent">
                <spinner ref="spinner" size="md" text="Loading ..." />
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Image *</label>
                  <div class="col-md-10">
                    <image-uploader
                      ref="uploader"
                      :uploaded-img-url="source.image ? source.image.public_url : null"
                      :removable="false"
                      @changeFile="coverChange"
                    />
                  </div>
                </div>
                <template v-for="(quote, key) in entity.quotes">
                  <PaintingQuote
                    :key="key"
                    :quote="quote"
                    :number="key"
                    @deleteQuote="onDeleteQuote"
                  />
                </template>
                <button class="btn btn-success" @click="addQuote">
                  Add Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Painting image has added successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import PaintingGameMixin from '@/mixins/PaintingGameMixin';
import PaintingQuote from './PaintingQuote.vue';

export default {
  name: 'PaintingImageNew',

  components: {
    PaintingQuote,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests, PaintingGameMixin],

  methods: {
    isEntityValid() {
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Image', value: this.entity.painting_image, type: 'required' },
      ];
      return this.$_validate(filelds);
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', JSON.stringify(this.entity.quotes));
      postFormData.append('painting_image', this.entity.painting_image);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/painting`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/painting-game-images/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    coverChange(file) {
      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = () => {
          this.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.painting_image = file;
        return;
      }
      this.imageSelected = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?4c32fc16